"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WasmWeb3Api = void 0;
var imports_1 = require("./imports");
var core_js_1 = require("@web3api/core-js");
var MsgPack = __importStar(require("@msgpack/msgpack"));
var tracing_js_1 = require("@web3api/tracing-js");
var asyncify_js_1 = require("@web3api/asyncify-js");
var hasExport = function (name, exports) {
    if (!exports[name]) {
        return false;
    }
    return true;
};
var WasmWeb3Api = /** @class */ (function (_super) {
    __extends(WasmWeb3Api, _super);
    function WasmWeb3Api(_uri, _manifest, _uriResolver, _clientEnv) {
        var _this = _super.call(this) || this;
        _this._uri = _uri;
        _this._manifest = _manifest;
        _this._uriResolver = _uriResolver;
        _this._clientEnv = _clientEnv;
        _this._wasm = {
            query: undefined,
            mutation: undefined,
        };
        _this._sanitizedEnv = {
            query: undefined,
            mutation: undefined,
        };
        tracing_js_1.Tracer.startSpan("WasmWeb3Api: constructor");
        tracing_js_1.Tracer.setAttribute("input", {
            uri: _this._uri,
            manifest: _this._manifest,
            clientEnv: _this._clientEnv,
            uriResolver: _this._uriResolver,
        });
        tracing_js_1.Tracer.endSpan();
        return _this;
    }
    WasmWeb3Api.prototype.getManifest = function (options, client) {
        return __awaiter(this, void 0, void 0, function () {
            var manifest, fileTitle, path, _a, path;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(options === null || options === void 0 ? void 0 : options.type)) {
                            return [2 /*return*/, this._manifest];
                        }
                        fileTitle = options.type === "web3api" ? "web3api" : "web3api." + options.type;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 5]);
                        path = fileTitle + ".yaml";
                        return [4 /*yield*/, this.getFile({ path: path, encoding: "utf8" }, client)];
                    case 2:
                        manifest = (_b.sent());
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        path = fileTitle + ".yml";
                        return [4 /*yield*/, this.getFile({ path: path, encoding: "utf8" }, client)];
                    case 4:
                        manifest = (_b.sent());
                        return [3 /*break*/, 5];
                    case 5:
                        switch (options.type) {
                            case "build":
                                return [2 /*return*/, core_js_1.deserializeBuildManifest(manifest)];
                            case "meta":
                                return [2 /*return*/, core_js_1.deserializeMetaManifest(manifest)];
                            default:
                                return [2 /*return*/, core_js_1.deserializeWeb3ApiManifest(manifest)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    WasmWeb3Api.prototype.getFile = function (options, client) {
        return __awaiter(this, void 0, void 0, function () {
            var path, encoding, _a, data, error, decoder, text;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        path = options.path, encoding = options.encoding;
                        return [4 /*yield*/, core_js_1.UriResolver.Query.getFile(function (options) { return client.invoke(options); }, this._uriResolver, core_js_1.combinePaths(this._uri.path, path))];
                    case 1:
                        _a = _b.sent(), data = _a.data, error = _a.error;
                        if (error) {
                            throw error;
                        }
                        // If nothing is returned, the file was not found
                        if (!data) {
                            throw Error("WasmWeb3Api: File was not found.\nURI: " + this._uri + "\nSubpath: " + path);
                        }
                        if (encoding) {
                            decoder = new TextDecoder(encoding);
                            text = decoder.decode(data);
                            if (!text) {
                                throw Error("WasmWeb3Api: Decoding the file's bytes array failed.\nBytes: " + data);
                            }
                            return [2 /*return*/, text];
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    WasmWeb3Api.prototype.invoke = function (options, client) {
        return __awaiter(this, void 0, void 0, function () {
            var invokableModule_1, method_1, noDecode, input_1, wasm, state, abort, memory, instance, exports_1, result, invokeResult, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        invokableModule_1 = options.module, method_1 = options.method, noDecode = options.noDecode;
                        input_1 = options.input || {};
                        return [4 /*yield*/, this._getWasmModule(invokableModule_1, client)];
                    case 1:
                        wasm = _a.sent();
                        state = {
                            invoke: {},
                            subinvoke: {
                                args: [],
                            },
                            invokeResult: {},
                            method: method_1,
                            sanitizeEnv: {},
                            args: input_1 instanceof ArrayBuffer
                                ? input_1
                                : MsgPack.encode(input_1, { ignoreUndefined: true }),
                        };
                        abort = function (message) {
                            throw new Error("WasmWeb3Api: Wasm module aborted execution.\nURI: " + _this._uri.uri + "\n" +
                                ("Module: " + invokableModule_1 + "\nMethod: " + method_1 + "\n") +
                                ("Input: " + JSON.stringify(input_1, null, 2) + "\nMessage: " + message + ".\n"));
                        };
                        memory = asyncify_js_1.AsyncWasmInstance.createMemory({ module: wasm });
                        return [4 /*yield*/, asyncify_js_1.AsyncWasmInstance.createInstance({
                                module: wasm,
                                imports: imports_1.createImports({
                                    state: state,
                                    client: client,
                                    memory: memory,
                                    abort: abort,
                                }),
                                requiredExports: WasmWeb3Api.requiredExports,
                            })];
                    case 2:
                        instance = _a.sent();
                        exports_1 = instance.exports;
                        return [4 /*yield*/, this._sanitizeAndLoadEnv(invokableModule_1, state, exports_1)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, exports_1._w3_invoke(state.method.length, state.args.byteLength)];
                    case 4:
                        result = _a.sent();
                        invokeResult = this._processInvokeResult(state, result, abort);
                        switch (invokeResult.type) {
                            case "InvokeError": {
                                throw Error("WasmWeb3Api: invocation exception encountered.\n" +
                                    ("uri: " + this._uri.uri + "\nmodule: " + invokableModule_1 + "\n") +
                                    ("method: " + method_1 + "\n") +
                                    ("input: " + JSON.stringify(input_1, null, 2) + "\n") +
                                    ("exception: " + invokeResult.invokeError));
                            }
                            case "InvokeResult": {
                                if (noDecode) {
                                    return [2 /*return*/, {
                                            data: invokeResult.invokeResult,
                                        }];
                                }
                                try {
                                    return [2 /*return*/, {
                                            data: MsgPack.decode(invokeResult.invokeResult),
                                        }];
                                }
                                catch (err) {
                                    throw Error("WasmWeb3Api: Failed to decode query result.\nResult: " + JSON.stringify(invokeResult.invokeResult) + "\nError: " + err);
                                }
                            }
                            default: {
                                throw Error("WasmWeb3Api: Unknown state \"" + state + "\"");
                            }
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        return [2 /*return*/, {
                                error: error_1,
                            }];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    WasmWeb3Api.prototype.getSchema = function (client) {
        return __awaiter(this, void 0, void 0, function () {
            var module, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this._schema) {
                            return [2 /*return*/, this._schema];
                        }
                        module = this._manifest.modules.mutation || this._manifest.modules.query;
                        if (!module) {
                            // TODO: this won't work for abstract APIs
                            throw Error("WasmWeb3Api: No module was found.");
                        }
                        _a = this;
                        return [4 /*yield*/, this.getFile({ path: module.schema, encoding: "utf8" }, client)];
                    case 1:
                        _a._schema = (_b.sent());
                        return [2 /*return*/, this._schema];
                }
            });
        });
    };
    WasmWeb3Api.prototype._processInvokeResult = function (state, result, abort) {
        if (result) {
            if (!state.invoke.result) {
                abort("Invoke result is missing.");
            }
            return {
                type: "InvokeResult",
                invokeResult: state.invoke.result,
            };
        }
        else {
            if (!state.invoke.error) {
                abort("Invoke error is missing.");
            }
            return {
                type: "InvokeError",
                invokeError: state.invoke.error,
            };
        }
    };
    WasmWeb3Api.prototype._sanitizeAndLoadEnv = function (module, state, exports) {
        return __awaiter(this, void 0, void 0, function () {
            var clientEnv;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!hasExport("_w3_load_env", exports)) return [3 /*break*/, 6];
                        if (!(this._sanitizedEnv[module] !== undefined)) return [3 /*break*/, 1];
                        state.env = this._sanitizedEnv[module];
                        return [3 /*break*/, 4];
                    case 1:
                        clientEnv = this._getModuleClientEnv(module);
                        if (!hasExport("_w3_sanitize_env", exports)) return [3 /*break*/, 3];
                        state.sanitizeEnv.args = MsgPack.encode({ env: clientEnv }, { ignoreUndefined: true });
                        return [4 /*yield*/, exports._w3_sanitize_env(state.sanitizeEnv.args.byteLength)];
                    case 2:
                        _a.sent();
                        state.env = state.sanitizeEnv.result;
                        this._sanitizedEnv[module] = state.env;
                        return [3 /*break*/, 4];
                    case 3:
                        state.env = MsgPack.encode(clientEnv, {
                            ignoreUndefined: true,
                        });
                        this._sanitizedEnv[module] = state.env;
                        _a.label = 4;
                    case 4: return [4 /*yield*/, exports._w3_load_env(state.env.byteLength)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    WasmWeb3Api.prototype._getModuleClientEnv = function (module) {
        if (!this._clientEnv) {
            return {};
        }
        if (module === "query") {
            return __assign(__assign({}, this._clientEnv.common), this._clientEnv.query);
        }
        else {
            return __assign(__assign({}, this._clientEnv.common), this._clientEnv.mutation);
        }
    };
    WasmWeb3Api.prototype._getWasmModule = function (module, client) {
        return __awaiter(this, void 0, void 0, function () {
            var moduleManifest, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._wasm[module] !== undefined) {
                            return [2 /*return*/, this._wasm[module]];
                        }
                        moduleManifest = this._manifest.modules[module];
                        if (!moduleManifest) {
                            throw Error("Package manifest does not contain a definition for module \"" + module + "\"");
                        }
                        if (!moduleManifest.module) {
                            throw Error("Package manifest module " + module + " does not contain a definition for module\"");
                        }
                        return [4 /*yield*/, this.getFile({ path: moduleManifest.module }, client)];
                    case 1:
                        data = (_a.sent());
                        this._wasm[module] = data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    WasmWeb3Api.requiredExports = ["_w3_invoke"];
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: getManifest")
    ], WasmWeb3Api.prototype, "getManifest", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: getFile")
    ], WasmWeb3Api.prototype, "getFile", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: invoke")
    ], WasmWeb3Api.prototype, "invoke", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: getSchema")
    ], WasmWeb3Api.prototype, "getSchema", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: _processInvokeResult")
    ], WasmWeb3Api.prototype, "_processInvokeResult", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: _sanitizeAndLoadEnv")
    ], WasmWeb3Api.prototype, "_sanitizeAndLoadEnv", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: _getModuleClientEnv")
    ], WasmWeb3Api.prototype, "_getModuleClientEnv", null);
    __decorate([
        tracing_js_1.Tracer.traceMethod("WasmWeb3Api: getWasmModule")
    ], WasmWeb3Api.prototype, "_getWasmModule", null);
    return WasmWeb3Api;
}(core_js_1.Api));
exports.WasmWeb3Api = WasmWeb3Api;
//# sourceMappingURL=WasmWeb3Api.js.map